import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

export const requestOrdersStatusFalabellaCollection = async (orderid) => {
  try {
    console.log(`Buscando orden con ID: ${orderid}`);

    const allOrdersRefFalabella = collection(
      db,
      process.env.REACT_APP_COL_FALABELLA_ORDERS
    );

    const ordersQuery = query(
      allOrdersRefFalabella,
      where("id", "==", orderid.toString())
    );

    const querySnapshot = await getDocs(ordersQuery);

    if (querySnapshot.empty) {
      console.warn(`Orden no encontrada: ${orderid}`);
      return {
        createdAtFalabella: false,
        falabella_status: false,
        updatedAt: false,
      };
    }

    const orderData = querySnapshot.docs[0].data();
    const orderId = querySnapshot.docs[0].id;

    const createdAtFalabella = orderData.createdAt;
    const falabella_status =
      orderData.falabella_status || orderData.int_falabella_status;
    const updatedAt = orderData.updatedAt;

    console.log(`Orden encontrada: ${orderid}`, {
      orderId,
      createdAtFalabella,
      falabella_status,
      updatedAt,
    });

    return { createdAtFalabella, falabella_status, updatedAt };
  } catch (error) {
    console.error(`Error al buscar el estado de la orden ${orderid}:`, error);
    return {
      createdAtFalabella: false,
      falabella_status: false,
      updatedAt: false,
    };
  }
};
